import { COLORS } from '@/styles/color';
import { mediaBreakpointUp, paddingY } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize } from '@/styles/typography/utils';
import styled from 'styled-components';

const Footer = styled.footer<{ $background?: string }>`
  background: ${(props) => props.$background ?? 'transparent'};
  background-position: left bottom;
  background-size: 150%;
  background-repeat: no-repeat;
  ${paddingY(0, 80)}

  ${mediaBreakpointUp('tablet')} {
    background-size: cover;
    background-position: center top;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
  gap: 60px;

  ${mediaBreakpointUp('tablet')} {
    grid-template-columns: repeat(12, 1fr);
    gap: 40px 20px;

    > div {
      grid-column: 2 / -2;
    }
  }

  ${mediaBreakpointUp('desktop')} {
    grid-template-columns: repeat(16, 1fr);
    align-items: flex-start;

    > div:first-child {
      grid-column: 1 / span 7;
      padding-top: 60px;
    }

    > div:last-child {
      grid-column: 9 / -1;
    }
  }
`;

const Heading = styled.h3`
  ${customTextSize(32, 38)}
  letter-spacing: -0.01em;
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  margin-bottom: 20px;

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(49, 58)}
    margin-bottom: 30px;
  }
`;

const Text = styled.div`
  ${customTextSize(18, 26)}

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(24, 34)}
  }
`;

const FormWrapper = styled.div`
  background: ${COLORS.WHITE};
  box-shadow: 0px 4px 20px rgba(0, 27, 56, 0.15);
  border-radius: 10px;
  padding: 30px;

  ${mediaBreakpointUp('desktop')} {
    height: 100%;
  }
`;

const formFooterComponents = {
  Footer,
  Grid,
  Heading,
  Text,
  FormWrapper,
};

export default formFooterComponents;
